export function styleUrl(styleName: string): string {
    return styleName.startsWith('mapbox://')? styleName : `mapbox://styles/mapbox/${styleName}`
}

export const defaultMapStyle = "mapbox://styles/mapbox/streets-v12"

type StandardMapStyle = {
    url: string
    name: string
    description: string
}

const mapStyles: Array<StandardMapStyle> = [
    {
        url: "mapbox://styles/mapbox/streets-v12",
        name: "Streets",
        description: "(Default) For general-use maps",
    },
    {
        url: "mapbox://styles/mapbox/outdoors-v12",
        name: "Outdoors",
        description: "For outdoor maps",
    },
    {
        url: "mapbox://styles/mapbox/light-v11",
        name: "Light",
        description: "Subtle and lightweight",
    },
    {
        url: "mapbox://styles/mapbox/dark-v11",
        name: "Dark",
        description: "Subtle and lightweight",
    },
    {
        url: "mapbox://styles/mapbox/satellite-v9",
        name: "Satellite",
        description: "Uses real satellite and aerial photography",
    },
    {
        url: "mapbox://styles/mapbox/satellite-streets-v12",
        name: "Satellite Streets",
        description: "Combines satellite with streets",
    },
]

export default mapStyles